module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step4_Image5b.8a9ca1e3.jpg";